'use client';

// ─────────────────────────────────────────────────────────────────────────────
// JobsTab — full Active Jobs grid with filter pills, crew overlay, search,
// and drag-to-reorder. ActiveJobsGrid owns its own data fetch, realtime
// subscription, and drag state — the tab just composes it and forwards
// the modal-trigger handlers from the orchestrator.
// ─────────────────────────────────────────────────────────────────────────────

import ActiveJobsGrid from '../ActiveJobsGrid';

interface JobsTabProps {
  onJobDetail: () => void;
  onEmployeeDirectory: () => void;
}

export default function JobsTab({ onJobDetail, onEmployeeDirectory }: JobsTabProps) {
  return (
    <div>
      <ActiveJobsGrid onJobClick={onJobDetail} onCustomerClick={onEmployeeDirectory} />
    </div>
  );
}
